<section class="gocardless-report" [attr.aria-label]="layout.ariaLabel">
  <div class="report-summary" aria-live="polite">
    <div><span>Total Records</span><strong>{{ totalRecords | number }}</strong></div>
    <div><span>Total Payment Amount</span><strong>{{ formatAmount(totalPaymentAmount) }}</strong></div>
  </div>

  <div class="gocardless-table-wrapper" (scroll)="onScroll($event)">
    <table class="gocardless-table" [style.min-width]="layout.columns.length > 5 ? '88rem' : '50rem'">
      <thead>
        <tr>
          @for (column of layout.columns; track column.value) {
            <th [class.amount-column]="column.value === 'payment-amount'">{{ column.label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          @for (_ of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
            <tr class="loading-row">
              @for (column of layout.columns; track column.value) { <td [class.amount-column]="column.value === 'payment-amount'"><span class="table-skeleton"></span></td> }
            </tr>
          }
        } @else {
          @for (repayment of repayments; track repayment.id) {
            <tr>
              @for (column of layout.columns; track column.value) {
                <td [class.amount-column]="column.value === 'payment-amount'">{{ valueFor(repayment, column.value) }}</td>
              }
            </tr>
          } @empty {
            <tr><td [attr.colspan]="layout.columns.length" class="empty-row">{{ layout.emptyMessage }}</td></tr>
          }
          @if (loadingMore) {
            @for (_ of [1, 2, 3]; track $index) {
              <tr class="loading-row">
                @for (column of layout.columns; track column.value) { <td [class.amount-column]="column.value === 'payment-amount'"><span class="table-skeleton"></span></td> }
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>
</section>
